/* eslint-disable no-param-reassign */
import API from 'api';
import Market from 'models/business/Market';
import Asset from 'models/business/Asset';

export default function useModelConvenience() {
  const populateMarket = async (ad) => {
    const result = await API.mall.getMallList();
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }
    const markets = (result.resultData || []).map((m) => new Market(m));
    const market = markets.find((m) => m.id === ad.marketId);
    if (!market) return null;
    ad.marketId = market.id;
    ad.injectMarket(market);
    return ad;
  };

  const populateMarketContentFeed = async (ad) => {
    const result = await API.mall.getMallAssets(ad.market.id);
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }

    const marketFeeds = (result.resultData || []).map((a) => new Asset(a));
    if (!marketFeeds.length) return null;
    ad.marketContentFeedId = marketFeeds[0].id;
    return ad;
  };

  const fullyPopulateMarket = async (ad) => (
    populateMarket(ad).then((ok) => ok && populateMarketContentFeed(ad))
  );

  return {
    populateMarket,
    populateMarketContentFeed,
    fullyPopulateMarket,
  };
}
